import QorusClient from "@/api/clients/QorusClient";
import Vue from "vue";
import Uicookie from "@/utils/cookie";
import { Customer } from "@/models/customer";
import { AxiosRequestConfig } from "axios";
import Locales from "@/utils/locales";

/**
 *  Qorus API about user's account
 */

export default class AccountService extends Vue {
  constructor() {
    super();
  }

  static of(): AccountService {
    return new AccountService();
  }

  login(customer: Customer): Promise<Customer> {
    const shoppingCartId = Uicookie.getCart();
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        shoppingCartId,
      },
    };

    return QorusClient.of().post("customers/sign-in", customer, axiosRequestConfig).then(
      (data: Customer) => {
        if (!data.twoFactorAuthenticationEnabled) {
          Uicookie.setCustomerToken(data.JWT);
        }
        return Customer.of(data);
      },
      data => {
        Uicookie.deleteCustomerToken();
        throw data;
      },
    );
  }


  paramsToObject(entries) {

    const result = {};
    for (const [key, value] of entries) { // each 'entry' is a [key, value] tupple
      result[key] = value;
    }
    return result;
  }


  checkAuth(customer: Customer): Promise<Customer> {
    const shoppingCartId = Uicookie.getCart();
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        shoppingCartId,
      },
    };

    return QorusClient.of().post("customers/one-time-password", {
      email: customer.email,
      password: customer.password,
      oneTimePassword: customer.oneTimePassword,
    }, axiosRequestConfig).then(
      (data: Customer) => {
        Uicookie.setCustomerToken(data.JWT);
        return Customer.of(data);
      },
      data => {
        Uicookie.deleteCustomerToken();
        throw data;
      },
    );
  }

  register(customer: Customer): Promise<Customer> {
    debugger;
    const shoppingCartId = Uicookie.getCart();
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        shoppingCartId,
      },
    };
    customer.locale = Locales.getLocaleCode();

    return QorusClient.of().post("customers/register", customer, axiosRequestConfig).then(
      (data: Customer) => {
        Uicookie.setCustomerToken(data.JWT);
        return Customer.of(data);
      },
      data => {
        Uicookie.deleteCustomerToken();
        throw data;
      },
    );
  }

  resetPassword(customer: Customer): Promise<void> {
    return QorusClient.of().get("customers/reset-password?customerEmail=" + customer.email).then(
      (data: void) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  logout(): void {
    Uicookie.deleteCart();
    Uicookie.deleteCustomerToken();
  }

  getProfile(userToken: string): Promise<Customer> {
    const shoppingCartId = Uicookie.getCart();
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        shoppingCartId,
      },
    };
    return QorusClient.of().get("customers/me", axiosRequestConfig).then(
      (data) => {
        return Customer.of(data);
      },
      data => {
        Uicookie.deleteCustomerToken();
        throw data;
      },
    );

  }

  updateProfile(customer: Customer): Promise<any> { /* TODO */
    return QorusClient.of().patch("customers", customer).then(
      (data) => {
        return;
      },
      err => {
        throw err;
      },
    );
  }

  updatePassword(passwords: { oldPassword: string, newPassword: string }): Promise<any> {

    return QorusClient.of().post("customers/change-password", passwords).then(
      () => {
        return;
      },
      err => {
        throw err;
      },
    );
  }

  getAddresses() { /* TODO */
  }

//update same as addAddress
  //TODO a virer adresseKey
  /* addAddress(address): Promise<any> {
     const userToken = Uicookie.getCustomerToken();

     const axiosRequestConfig: AxiosRequestConfig = {
       headers: {
         "Customer-Authorization": userToken,
       },
       params: {
         addressName: address.addressKey,
         defaultShipping: address.defaultShipping,
         defaultBilling: address.defaultBilling,
       },
     };
     return QorusClient.of().post("customers/address/" + address.addressKey, address, axiosRequestConfig).then(
       (data) => {
         return data;
       },
       data => {
         throw data;
       },
     );
   }*/

  addAddress(address): Promise<any> {
    const axiosRequestConfig: AxiosRequestConfig = {

      params: {
        defaultShipping: address.defaultShipping,
        defaultBilling: address.defaultBilling,
      },
    };
    return QorusClient.of().post("customers/address", address, axiosRequestConfig).then(
      (data) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  removeAddress(addressName): Promise<any> { /* TODO */

    return QorusClient.of().delete("customers/address/" + addressName).then(
      (data) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  changeResetPassword(params): Promise<any> {

    return QorusClient.of().post("customers/change-password/" + params.resetToken, { newPassword: params.newPassword }).then(
      (data) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  subscribeNewsletter(customerEmail): Promise<any> {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        customerEmail
      },
    };
    return QorusClient.of().put("customers/newsletter/subscribe", null,axiosRequestConfig).then(
        (data) => {
          return data;
        },
        data => {
          throw data;
        },
    );
  }

  unSubscribeNewsletter(customerEmail): Promise<any> {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        customerEmail
      },
    };
    return QorusClient.of().put("customers/newsletter/unsubscribe",null,axiosRequestConfig ).then(
        (data) => {
          return data;
        },
        data => {
          throw data;
        },
    );
  }

}